'use client';

import { useEffect, useRef } from 'react';
import { Button } from 'react-bootstrap';

function scrollToFirstTarget(targetIds = []) {
  if (typeof document === 'undefined') {
    return false;
  }

  const target = targetIds
    .map((id) => document.getElementById(id))
    .find(Boolean);

  if (!target) {
    return false;
  }

  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  return true;
}

export default function SearchBtn({
  onClick,
  showSearchInput = false,
  shouldScroll = false,
  scrollTargetIds = [],
  ariaLabel = 'Search',
  title,
  className = '',
  iconClassName = '',
}) {
  const searchBtnRef = useRef(null);

  useEffect(() => {
    if (!showSearchInput) {
      const timeoutId = window.setTimeout(() => {
        searchBtnRef.current?.classList.remove('fade-out');
      }, 1000);

      return () => window.clearTimeout(timeoutId);
    }

    return undefined;
  }, [showSearchInput]);

  useEffect(() => {
    searchBtnRef.current?.classList.remove('fade-out');
  });

  const handleSearchClick = () => {
    if (shouldScroll && scrollToFirstTarget(scrollTargetIds)) {
      return;
    }

    onClick?.();
  };

  return (
    <Button
      ref={searchBtnRef}
      type="button"
      variant="transparent"
      onClick={handleSearchClick}
      aria-label={ariaLabel}
      title={title || ariaLabel}
      className={`search-btn d-flex align-items-center p-0 fade-out fs-2 fs-sm-4 text-white shadow-none bg-transparent border-0 ${className}`.trim()}
    >
      <span
        aria-hidden="true"
        className={iconClassName}
        title={title || ariaLabel}
      >
        🔍
      </span>
    </Button>
  );
}
